import React from "react";
import { Box, Container, Grid, Typography, Paper, Link, IconButton } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import { useTranslation } from "react-i18next";
import { useBrand } from "../brand/BrandContext";
import { resolveBrandContacts } from "../brand/contacts";
import { socialLinks } from "../brand/socialLinks";

const ContactPage = () => {
  const { t } = useTranslation("common");
  const brand = useBrand();
  const COMPANY_CONTACTS = resolveBrandContacts(brand);
  return (
    <Box sx={{ backgroundColor: "background.paper", py: 6, px: { xs: 2, sm: 4 }, minHeight: "40vh" }}>
      <Container maxWidth="md">
        <Typography variant="h4" sx={{ fontWeight: 700, mb: 4, color: "text.primary" }}>
          {t("contact.title")}
        </Typography>

        <Paper elevation={0} variant="outlined" sx={{ p: 4, borderRadius: 3 }}>
          <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
              <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                {t("contact.subtitle")}
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <EmailIcon sx={{ color: "primary.main", mr: 1 }} />
                <Link
                  href={`mailto:${COMPANY_CONTACTS.email}`}
                  underline="hover"
                  color="inherit"
                >
                  {COMPANY_CONTACTS.email}
                </Link>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <PhoneIcon sx={{ color: "primary.main", mr: 1 }} />
                <Link
                  href={`tel:${COMPANY_CONTACTS.primaryPhoneTel}`}
                  underline="hover"
                  color="inherit"
                >
                  {COMPANY_CONTACTS.primaryPhone}
                </Link>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 2 }}>
                {socialLinks(COMPANY_CONTACTS).map(({ href, label, Icon }) => (
                  <IconButton
                    key={label}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={label}
                  >
                    <Icon sx={{ color: "text.primary" }} />
                  </IconButton>
                ))}
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                {t("contact.schedule")}
              </Typography>
              <Typography>{t("contact.scheduleWeekday")}</Typography>
              <Typography>{t("contact.scheduleWeekend")}</Typography>
            </Grid>
          </Grid>
        </Paper>
      </Container>
    </Box>
  );
};

export default ContactPage;
